import { jsx } from 'react/jsx-runtime';
import { useMemo, cloneElement } from 'react';
import classNames from 'classnames';
import { StatusTrackProvider } from './StatusTrackerContext/provider.es.js';
import { StatusTrackerDescription } from './StatusTrackerDescription/StatusTrackerDescription.es.js';
import { StatusTrackerLabel } from './StatusTrackerLabel/StatusTrackerLabel.es.js';
import { StatusTrackerLoading } from './StatusTrackerLoading/StatusTrackerLoading.es.js';
import { StatusTrackerStep } from './StatusTrackerStep/StatusTrackerStep.es.js';

const StatusTracker = ({ loading = false, numLoadingSteps = 2, className, children, locale = {
    label: 'Status Tracker'
}, ...rest })=>{
    const childrenArray = useMemo(()=>Array.isArray(children) ? children : [
            children
        ], [
        children
    ]);
    return jsx(StatusTrackProvider, {
        loading: loading,
        numLoadingSteps: numLoadingSteps,
        children: jsx("ol", {
            "aria-label": locale.label,
            className: classNames('cb-status-tracker', className),
            "data-testid": "status-tracker",
            ...rest,
            children: loading ? jsx(StatusTrackerLoading, {}) : childrenArray.map((step, index)=>{
                return /*#__PURE__*/ cloneElement(step, {
                    ...step.props,
                    key: index,
                    isLastStep: index === childrenArray.length - 1
                });
            })
        })
    });
};
StatusTracker.Step = StatusTrackerStep;
StatusTracker.Label = StatusTrackerLabel;
StatusTracker.Description = StatusTrackerDescription;
StatusTracker.displayName = 'StatusTracker';

export { StatusTracker as default };
//# sourceMappingURL=StatusTracker.es.js.map
